import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isPhoneNumber } from '@shared/functions/format-document';

export const PixValidators = {
  cpf(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.replace(/\D/g, '');
    if (!value || value.length !== 11) return { cpf: true };

    if (/^(\d)\1{10}$/.test(value)) return { cpf: true };

    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(value.charAt(i), 10) * (10 - i);
    }
    let remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(value.charAt(9), 10)) return { cpf: true };

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(value.charAt(i), 10) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(value.charAt(10), 10)) return { cpf: true };

    return null;
  },

  cnpj(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.replace(/\D/g, '');
    if (!value || value.length !== 14) return { cnpj: true };

    if (/^(\d)\1{13}$/.test(value)) return { cnpj: true };

    const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(value.charAt(i), 10) * weights1[i];
    }
    let remainder = sum % 11;
    const digit1 = remainder < 2 ? 0 : 11 - remainder;
    if (digit1 !== parseInt(value.charAt(12), 10)) return { cnpj: true };

    sum = 0;
    for (let i = 0; i < 13; i++) {
      sum += parseInt(value.charAt(i), 10) * weights2[i];
    }
    remainder = sum % 11;
    const digit2 = remainder < 2 ? 0 : 11 - remainder;
    if (digit2 !== parseInt(value.charAt(13), 10)) return { cnpj: true };

    return null;
  },

  email(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    const regex = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/i;
    return regex.test(control.value) ? null : { email: true };
  },

  phone(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    return isPhoneNumber(control.value, false) ? null : { phone: true };
  },

  randomKey(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(control.value) ? null : { randomKey: true };
  },
};
